/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./styles/FlippedClass.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { Link } from "react-router-dom";
import { getImageURL } from "../../utils/url";
import { TaskCards } from "../TaskList/components/TaskCards";

const FlippedClassStyle = {
  backgroundImage: `url(${
    process.env.PUBLIC_URL + "/backgrounds/revisionTask/nature.png"
  })`,
  backgroundSize: "cover",
  minHeight: "245px",
  height: "100%",
  borderBottomRightRadius: "17px",
  borderBottomLeftRadius: "17px",
};
const fixThumbnailUrl = (url) => {
  if (!url) {
    return process.env.PUBLIC_URL + "/backgrounds/revisionTask/nature.png";
  }

  if (url.startsWith("https://")) {
    return url;
  } else {
    return "https://xcell-cms-files.s3.amazonaws.com/" + url;
  }
};
const FlippedClass = ({ selectedClass, selectedSubject }) => {
  const [flippedClasss, setFlippedClasss] = useState([]);
  const [flippedClassLoader, setFlippedClassLoader] = useState(true);

  useEffect(() => {
    const fetchFlippedClasss = async () => {
      const authToken = localStorage.getItem("authToken");
      const date = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
      ).toISOString();
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ORIGIN}/api/v1/tasks?public=true&taskType=flipped class&section=${selectedClass}&subject=${selectedSubject}`,
          {
            headers: {
              token: authToken,
            },
          },
        );
        console.log("Flipped class response->", response);
        if (response.data.status === "success") {
          setFlippedClasss(response.data.data.tasks);
        }
      } catch (error) {
        console.log(error);
      }

      setFlippedClassLoader(false);
    };

    fetchFlippedClasss();
  }, [selectedClass, selectedSubject]);

  return (
    <TaskCards
      tasks={flippedClasss}
      setTasks={setFlippedClasss}
      loading={flippedClassLoader}
      message={"No flipped class task assigned"}
    />
  );
};

export default FlippedClass;
